
import { $,_,Backbone,Marionette,Radio,Foundation,moment } from '../../../vendor';
import { Backform,Dependencies,Notification } from '../../utils';
import InboomaBaseView from '../InboomaBaseView';
import InboomaBaseCollectionView from '../InboomaBaseCollectionView'

import OffCanvasBehavior from '../../behaviors/Behavior.OffCanvas';

import Users from  '../../collections/Users'
import Pricediscount from '../../models/Pricediscount';
import Pricetariffs from  '../../collections/Pricetariffs'
import UserDiscountTpl from '../../templates/pricediscounts/UserDiscount.html';

const UserDiscountView = InboomaBaseView.extend({

    template : UserDiscountTpl,
    parentView : 'pricediscounts', // For routing back

    ui : {
        save : '.inb-dropdown',
        toggleBtn : '.inb-toggle-order-dd',
        selectRole : '.inb-role-select',
        removeUser : '.inb-pricediscount-remove',
    },

    events : {
        'change @ui.selectRole' : '_roleChanged',
    },

    templateContext () {
        return {
            _,
            moment
        }
    },


    initialize () {
        const that = this;
        new Dependencies(
            {
                'users': new Users(),
                'pricetariffs': new Pricetariffs()
            }
        ).then(() => {
            that.users = Radio.channel('users').request('get:data');
            that.pricetariffs = Radio.channel('pricetariffs').request('get:data');
            let users_arr =[];
            _.each(that.users.models, (user) => {
                users_arr.push({ label : user.get('first_name')+ ' '+user.get('last_name'), value : user.get('id') });
            });
        let pricetariffs_arr = [{
            label: "",
            value: ""
        }];
        _.each(this.pricetariffs.models, (pricetariff) => {
            pricetariffs_arr.push({
            label: pricetariff.get('name'),
            value: pricetariff.get('id')
        });
        });
            const fields = [
                {
                    name: "user_id",
                    control: "selector",
                    options: users_arr,
                    disabled: (this.model.get('id') != ''),
                    required: true,
                    size : {
                        "large" : "4"
                    }
                },
                {
                    name: "description",
                    control: "input",
                    helpMessage: (this.model.get('description') == '' ? this.t('no_special_char_allowed') : ''),
                    required: true,
                    size : {
                        "large" : "4"
                    }
                },{
                    name : "discount_amount",
                    control : "input",
                    required: false,
                    size : {
                        "small" : "1"
                    }
                },{
                    name: "discount_percent",
                    control: "input",
                    required: false,
                    size : {
                        "small" : "1"
                    }
                }, {
                    name: "active",
                    control: "checkbox",
                    required: false,
                    size : {
                        "small" : "1"
                    }
                }, {
                    name: "combineable",
                    control: "checkbox",
                    required: false,
                    size : {
                        "small" : "1"
                    }
                 }, {
                    name: "pricetariff_id",
                    label: this.t("pricetariff",null,"capital"),
                    control: "selector",
                    options: pricetariffs_arr,
                    disabled: (this.model.get('id') != ''),
                    required: false,
                    size: {
                        "large": "4"
                    }
                }, {
                    // @TODO begin & end: make require & controle variable
                    name: "valid_from",
                    label: this.t('valid_from',null,'capital'),
                    control: "datetimepicker",
                    //required: true,
                    minDate: null,
                    size : {
                        "small" : "6",
                        "large" : "3"
                    },
                    triggerPicker: 'valid_to'
                }, {
                    name: "valid_to",
                    label: this.t('valid_to',null,'capital'),
                    minDate:  null,
                    control: "datetimepicker",
                    //required: true,
                    size : {
                        "small" : "6",
                        "large" : "3"
                    }
                },{
                    name: "save",
                    control: "button",
                    controlClass: ['discount_save'],
                    label: this.t("save",null,"capital"),
                    size: {
                        "small": "2",
                        "large": "1"
                    }
                }

            ];
            that.render();
            that.form = new Backform.Form({

                el: that.$el.find('form'),
                model: this.model,
                fields: fields,
                events : {
                    "click .button" : (ev) => {
                            // Does exactly what OffCanvasBehavior does...
                           ev.preventDefault();
                           this.$el.find('form button[type="submit"]').prepend('<img class="rollingLoader" src="assets/img/rolling_loader.svg" />');

                                // @todo use InboomaBaseModel mixin
                                this.model = OffCanvasBehavior.prototype.normalizeModel(this.model);
                                this.model.attributes.valid_from = (this.model.get('valid_from') !=null)?OffCanvasBehavior.prototype.makeApiTime(this.model.get('valid_from')):null;
                                this.model.attributes.valid_to = (this.model.get('valid_to') !=null)?OffCanvasBehavior.prototype.makeApiTime(this.model.get('valid_to')):null;

                                that.$el.removeClass('.model-changed');

                                this.model.save(null,{
                                    success: (model, response, options) => {

                                        that.$el.find('.rollingLoader').fadeOut('fast')

                                        that.$el.find('.accordion-title').trigger('click'); //removeClass('is-active');
                                        //model.set('contingents', response.data.contingents[0].id);

                                        new Notification({
                                            message : that.t('saved_${a}',{a:that.t('user_discount')},null,'capital'),
                                            duration : 5000,
                                            type : 'success',
                                            closeable : true,
                                            icon : 'fi fi-check'
                                        });



                                        //that.model.trigger('changed');
                                        //that.render();
                                        document.location.href = "/pricediscounts/user_discount";
                                    }, error: function(model, xhr, options) {

                                        that.$el.find('.accordion-item').removeClass('is-active');

                                        new Notification({
                                            message : that.t('request_error'),
                                            duration : 5000,
                                            type : 'warning',
                                            closeable : true,
                                            icon : 'fi fi-x'
                                        });

                                    }});

                            }
                        }
                }
            );

            that.form.render();
        });
    },

});

export default InboomaBaseCollectionView.extend({
    childView: UserDiscountView,
    template: _.noop,
    initialize: function () {
        const that = this;
        if(that.id){
            that.collection.filterById(that.id);
        }else{
            that.collection.filterByType('user');
        }
       InboomaBaseCollectionView.prototype.initialize.apply(that);

            that.$el.html('');
            $('.inb-c-left-bar__footer').removeClass('hide');
            that.render();

    }
});